import { render, staticRenderFns } from "./DetalhesContratoRegistroPreco.vue?vue&type=template&id=cdf26bd8"
import script from "./DetalhesContratoRegistroPreco.vue?vue&type=script&lang=ts"
export * from "./DetalhesContratoRegistroPreco.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports